module.exports = __webpack_public_path__ + "img/editComment.1d37b24e.svg";